import { ROUTE_NAME } from 'enums/routes'

export const META_PARAM = {
  ALL_NEWS: 'Homepage'
}

export const IL_GROUP_TYPE = {
  STATIC: 'Static',
  ARTICLE: 'Article',
  CATEGORY: 'Category',
  TAG: 'Tag',
  TERM: 'Term',
  AUTHOR: 'Author'
}

const IL_GROUP_TYPES_BY_ROUTE_NAME = {
  [ROUTE_NAME.CATEGORY]: [IL_GROUP_TYPE.CATEGORY],
  [ROUTE_NAME.EDUCATION]: [IL_GROUP_TYPE.CATEGORY],
  [ROUTE_NAME.CATEGORY_ARTICLE]: [IL_GROUP_TYPE.ARTICLE],
  [ROUTE_NAME.CATEGORY_ARTICLE_AMP]: [IL_GROUP_TYPE.ARTICLE],
  [ROUTE_NAME.TAG_TAG]: [IL_GROUP_TYPE.TAG],
  [ROUTE_NAME.TERMS_LETTER_TERM]: [IL_GROUP_TYPE.TERM],
  [ROUTE_NAME.AUTHOR_AUTHOR]: [IL_GROUP_TYPE.AUTHOR]
}

export const getIlGroupTypesByPageName = pageName => {
  return IL_GROUP_TYPES_BY_ROUTE_NAME[pageName] || [IL_GROUP_TYPE.STATIC]
}

export const IL_TEMPLATE_PARAM = {
  [IL_GROUP_TYPE.STATIC]: {
    META_TITLE: 'PAGE_NAME',
    META_DESCRIPTION: 'PAGE_NAME'
  },
  [IL_GROUP_TYPE.ARTICLE]: {
    META_TITLE: 'ARTICLE_TITLE',
    META_DESCRIPTION: 'ARTICLE_TLDR'
  },
  [IL_GROUP_TYPE.CATEGORY]: {
    META_TITLE: 'CATEGORY_NAME',
    META_DESCRIPTION: 'CATEGORY_NAME'
  },
  [IL_GROUP_TYPE.TAG]: {
    META_TITLE: 'TAG_NAME',
    META_DESCRIPTION: 'TAG_NAME'
  },
  [IL_GROUP_TYPE.TERM]: {
    META_TITLE: 'TERM_NAME',
    META_DESCRIPTION: 'TERM_NAME'
  },
  [IL_GROUP_TYPE.AUTHOR]: {
    META_TITLE: 'AUTHOR_NAME',
    META_DESCRIPTION: 'AUTHOR_NAME'
  }
}

const IL_TEMPLATE_PARAMS_LIST = Object.values(IL_TEMPLATE_PARAM)

export const IL_META_TITLE_PARAMS_REGEX = new RegExp(
  IL_TEMPLATE_PARAMS_LIST.map(({ META_TITLE }) => META_TITLE).join('|'),
  'g'
)

export const IL_META_DESCRIPTION_PARAMS_REGEX = new RegExp(
  IL_TEMPLATE_PARAMS_LIST.map(({ META_DESCRIPTION }) => META_DESCRIPTION).join(
    '|'
  ),
  'g'
)

/** Needed to request SEO settings for some pages for global usage **/
export const IL_STATIC_PAGE = {
  ERROR: 'error/',
  HOMEPAGE: '/'
}
